import { useQuery } from '@tanstack/react-query'

import { getApprovers } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchApprovers = (userAccountId: string) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!userAccountId,
    queryFn: () =>
      getApprovers(axiosInstance, {
        userAccountId,
      }),
    queryKey: [`${REACT_QUERY_CACHE_KEYS.GET_APPROVERS}_${userAccountId}`],
  })

  return { data, isError, isLoading }
}
